import React, { useEffect, useState } from 'react';

import { useAppStore, useAuthStore } from '../../stores';
import { getAuthClient } from '../../utils/auth';

import Modal from '../Modal/Modal';
import ModalContentBasic from '../Modal/ModalContentBasic';
import TimeoutMessage from './TimeoutMessage';

import './Timeout.scss';

const auth = getAuthClient();

const timeoutMin = 60;
const timeoutSec = 0;
const idleWarningMin = 0;
const idleWarningSec = 30;

// for testing
// const timeoutMin = 0;
// const timeoutSec = 5;
// const idleWarningMin = 0;
// const idleWarningSec = 30;

const Timeout = () => {
  const [ showIdleWarning, setShowIdleWarning ] = useState( false );
  const [ isIdle, setIsIdle ] = useState( true );
  const [ minutes, setMinutes ] = useState( timeoutMin );
  const [ seconds, setSeconds ] = useState( timeoutSec );
  const [ modalIsOpen, setModalIsOpen ] = useState( true );
  const [ enableTimeout, setEnableTimeout ] = useState( false );

  // Zustand stores
  const settings = useAppStore((state) => state.settings);
  const appStatus = useAppStore((state) => state.appStatus);
  const setPricingTriggered = useAppStore((state) => state.setPricingTriggered);
  const setIsLoggedIn = useAuthStore((state) => state.setIsLoggedIn);

  const { isPublic, platform } = settings || {};

  // Do we want to enable the timeout?
  useEffect( () => {
    if (
      appStatus === 'operational'
      && !isPublic
      && platform
    ) {
      setEnableTimeout( true );
    } else {
      setEnableTimeout( false );
    }
  }, [ appStatus, isPublic, platform ] );

  // attach listeners for any movement for timeout
  useEffect( () => {
    if ( enableTimeout ) {
      const eventTypes = [
        'mousemove',
        'keydown',
        'wheel',
        'DOMMouseScroll',
        'mousewheel',
        'mousedown',
        'touchstart',
        'touchmove',
        'MSPointerDown',
        'MSPointerMove',
        'visibilitychange',
      ];

      const handleActivity = () => {
        // trigger the reset of the countdown
        setIsIdle( false );
        // return the state to default
        setIsIdle( true );
      };

      // Scroll-related events should be passive for better performance
      const passiveEvents = ['wheel', 'DOMMouseScroll', 'mousewheel', 'touchstart', 'touchmove'];

      eventTypes.forEach( ( event ) => {
        const options = passiveEvents.includes(event) ? { passive: true } : undefined;
        window.addEventListener( event, handleActivity, options );
      } );

      // Cleanup function to remove event listeners
      return () => {
        eventTypes.forEach( ( event ) => {
          const options = passiveEvents.includes(event) ? { passive: true } : undefined;
          window.removeEventListener( event, handleActivity, options );
        } );
      };
    }
  }, [ enableTimeout ] );

  // reset countdown if user is not idle
  // don't let movement events reset the countdown once the warning modal shows
  useEffect( () => {
    if ( !isIdle && !showIdleWarning ) {
      setMinutes( timeoutMin );
      setSeconds( timeoutSec );
    }
  }, [ isIdle, showIdleWarning ] );

  // countdown
  useEffect( () => {
    if ( enableTimeout ) {
      const myInterval = setInterval( () => {
        setSeconds( ( prevSeconds ) => {
          if ( prevSeconds > 0 ) {
            return prevSeconds - 1;
          }
          // When seconds reach 0, check if we need to decrement minutes
          setMinutes( ( prevMinutes ) => {
            if ( prevMinutes === 0 ) {
              clearInterval( myInterval );
              return prevMinutes;
            }
            return prevMinutes - 1;
          } );
          return 59; // Reset seconds to 59 when minutes decrement
        } );
      }, 1000 );

      return () => {
        clearInterval( myInterval );
      };
    }
  }, [ enableTimeout ] );

  // warn that timeout is coming - show idle warning
  useEffect( () => {
    if ( minutes === idleWarningMin && seconds === idleWarningSec ) {
      setShowIdleWarning( true );
    }
  }, [ minutes, seconds ] );

  // timeout the app and close modal
  useEffect( () => {
    // on load, min and sec are 0
    // so we also have to check that the showIdleWarning has been triggered
    // so we dont close the app on load, just when the countdown has ended
    if ( minutes === 0 && seconds === 0 && showIdleWarning === true ) {
      //setShowIdleWarning( false );
      auth.logout();
    }
  }, [
    minutes, seconds, showIdleWarning,
  ] );

  // reset countdown on click
  const handleClick = () => {
    setIsIdle( false );
    setShowIdleWarning( false );
    setModalIsOpen( false );
  };

  const btns = [ {
    key: 'resumeSession',
    class: 'modalBtn modalBtn--primary',
    func: handleClick,
    text: 'Resume Session',
  } ];

  return (
    <Modal
      isOpen={showIdleWarning}
      modalSize="small"
      showBlur
     // handleModalHide={handleClick}
    >
      <ModalContentBasic
        title="YourTour Session Expiring Soon"
        buttons={btns}
        className="timeout"
      >
        <div className="modal__section">
          <TimeoutMessage />

          <div className="modal__subsection timeout__countdown">
            <div className="timeout__countdownClock">
              {minutes}
              :
              { seconds < 10 ? `0${seconds}` : seconds}
            </div>
          </div>

          <div className="modal__subsection modal__description">
            To resume the session, click the button below.
          </div>
        </div>

      </ModalContentBasic>
    </Modal>
  );
};

export default Timeout;
